



















import { defineComponent } from '@nuxtjs/composition-api';

type IntegrationCardProps = Blok & {
  content: Blok[];
  link: BlokFieldLink;
  category: string;
  soonBadge: boolean;
};

export default defineComponent({
  props: {
    blok: {
      type: Object as () => IntegrationCardProps,
      required: true,
    },
  },

  data: ({ blok }) => ({ hasLink: !!blok?.link?.url }),
});
